import proto from "./osmosis/proto";
import { MsgGrant, MsgRevoke } from "cosmjs-types/cosmos/authz/v1beta1/tx";
import { MsgSwap } from "@terra-money/terra.proto/terra/market/v1beta1/tx";
import { MsgExecuteContract } from "@terra-money/terra.proto/terra/wasm/v1beta1/tx";

export const extendedRegistryTypes = {
  "/osmosis.gamm.v1beta1.MsgSwapExactAmountIn":
    proto.osmosis.gamm.v1beta1.MsgSwapExactAmountIn,
  "/cosmos.authz.v1beta1.MsgGrant": MsgGrant,
  "/cosmos.authz.v1beta1.MsgRevoke": MsgRevoke,
  "/terra.market.v1beta1.MsgSwap": MsgSwap,
  "/terra.wasm.v1beta1.MsgExecuteContract": MsgExecuteContract,
};
